import 'intersection-observer';
import React, { StrictMode, Fragment } from "react";
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact, { BugsnagPluginReactResult } from '@bugsnag/plugin-react'
import ReactDOM from "react-dom";
import { Helmet } from "react-helmet";
import { Provider } from "react-redux";
import store, { persistor } from "store";
import { PersistGate } from "redux-persist/integration/react";
import Loading from "pages/loading";
import { BrowserRouter } from "react-router-dom";
import ScrollTop from "components/scrollTop";
import { ToastContainer } from "react-toastify";
import App from "app";

const BUGSNAG_ID: string | undefined = process.env.REACT_APP_BUGSNAG_ID;
const BUGSNAG_ENV: string | undefined = process.env.REACT_APP_BUGSNAG_ENV;
const APP_TITLE: string | undefined = process.env.REACT_APP_TITLE;
const APP_VERSION: string | undefined = process.env.REACT_APP_VERSION;

if (BUGSNAG_ID) {
  Bugsnag.start({
    apiKey: BUGSNAG_ID,
    releaseStage: BUGSNAG_ENV,
    appVersion: APP_VERSION,
    plugins: [new BugsnagPluginReact()],
  });
}

const ReactPlugin: BugsnagPluginReactResult | undefined = Bugsnag.getPlugin('react');
const ErrorBoundary = (BUGSNAG_ID && ReactPlugin != undefined) ? 
  ReactPlugin.createErrorBoundary(React) : 
  Fragment;

ReactDOM.render(
  <ErrorBoundary>
    <StrictMode>
      <Provider store={store}>
        <Helmet>
          <title>{APP_TITLE}</title>
        </Helmet>
        <BrowserRouter>
          <PersistGate loading={<Loading />} persistor={persistor}>
            <ScrollTop>
              <App />
            </ScrollTop>
          </PersistGate>
        </BrowserRouter>
        <ToastContainer
          autoClose={3000}
          className="toast-alert"
          position="top-center"
          hideProgressBar={true}
        />
      </Provider>
    </StrictMode>
  </ErrorBoundary>,
  document.getElementById("root")
);

//serviceWorker.unregister();
